import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
  0% {
    background-position-x: -200%;
  }
  100% {
    background-position-x: 200%;
  }
`;

const SkeletonElement = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  background-position-x: -200%;
  animation: 1.5s ${gradientAnimation} ease-in-out infinite;
  border-radius: 4px;
`;

const OrgSkeletonContainer = styled.div`
  text-align: center;
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  position: relative;
  height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.1);
  min-height: 280px;
`;

const ProgressSkeleton = styled(SkeletonElement)`
  position: absolute;
  right: 15px;
  top: 15px;
  width: 60px;
  height: 20px;
  border-radius: 10px;
`;

const ImageSkeleton = styled(SkeletonElement)`
  width: 90px;
  height: 110px;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const TitleSkeleton = styled(SkeletonElement)`
  width: 80%;
  height: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
  border-radius: 6px;
`;

const ResponsibleSkeleton = styled(SkeletonElement)`
  width: 70%;
  height: 12px;
  margin-bottom: 5px;
  border-radius: 4px;
`;

const ContactSkeleton = styled(SkeletonElement)`
  width: 50%;
  height: 12px;
  border-radius: 4px;
`;

const OrgSkeleton = ({ id }) => {
  return (
    <OrgSkeletonContainer id={`org-skeleton-${id}`}>
      <ProgressSkeleton id={`org-skeleton-progress-${id}`} />
      <ImageSkeleton id={`org-skeleton-image-${id}`} />
      <TitleSkeleton id={`org-skeleton-title-${id}`} />
      <ResponsibleSkeleton id={`org-skeleton-responsible-${id}`} />
      <ContactSkeleton id={`org-skeleton-contact-${id}`} />
    </OrgSkeletonContainer>
  );
};

export default OrgSkeleton;
